import type { PropsWithChildren } from "react";
import { AppLayoutContext } from "#app-layout-context";
import { useAppLayoutContextValue } from "#app-layout-context-value";

export function AppLayoutContextProvider({ children }: PropsWithChildren) {
  const value = useAppLayoutContextValue();
  return <AppLayoutContext.Provider value={value}>{children}</AppLayoutContext.Provider>;
}
